import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import * as Subcompany from 'subcompanies/components';

import { getCompany, getPermissions } from 'auth/selectors';
import { toggleSubcompany } from 'subcompanies/actions';
import { addGrowlError, addGrowlSuccess } from 'messages/actions';

import { createRoute } from 'lib/util';

class SubcompanyContainer extends Component {
  static propTypes = {
    handleDelete: PropTypes.func.isRequired,
  };

  handleClick = (id) => {
    if (this.props.subcompany.active)
      this.props.history.push(createRoute(this.props.company.id, id, 'dashboard'));
  };

  handleToggle = (id) => {
    this.props
      .toggleSubcompany(this.props.company.id, id)
      .then(({ value }) => this.props.addGrowlSuccess(value.message))
      .catch((err) => err.code !== 401 && this.props.addGrowlError(err.message));
  };

  render() {
    const canEdit = this.props.permissions['acl.subcompanies.update'];
    const canDelete = this.props.permissions['acl.subcompanies.delete'];
    const canToggle = this.props.permissions['acl.subcompanies.toggle'];

    return (
      <Subcompany.Element
        subcompany={this.props.subcompany}
        company={this.props.company}
        canDelete={canDelete}
        canEdit={canEdit}
        canToggle={canToggle}
        handleClick={this.handleClick}
        handleDelete={this.props.handleDelete}
        handleToggle={this.handleToggle}
      />
    );
  }
}

const mapStateToProps = (state) => ({
  company: getCompany(state),
  permissions: getPermissions(state),
});

const mapDispatchToProps = { toggleSubcompany, addGrowlError, addGrowlSuccess };

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(SubcompanyContainer));



// WEBPACK FOOTER //
// src/modules/secured/modules/subcompanies/containers/SubcompanyContainer.js